module.exports = __webpack_public_path__ + "img/Qs.d2270060.png";